import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import VcfAdapterF from './VcfAdapter';
import VcfTabixAdapterF from './VcfTabixAdapter';
import ExtensionPointsF from './extensionPoints';
import VariantTrackF from './VariantTrack';
import Plugin from '@jbrowse/core/Plugin';
import ChordVariantDisplayF from './ChordVariantDisplay';
import LinearVariantDisplayF from './LinearVariantDisplay';
import StructuralVariantChordRendererF from './StructuralVariantChordRenderer';
import VariantFeatureWidgetF from './VariantFeatureWidget';
var VariantsPlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(VariantsPlugin, _Plugin);
  function VariantsPlugin() {
    var _this;
    _classCallCheck(this, VariantsPlugin);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(VariantsPlugin).apply(this, arguments));
    _this.name = 'VariantsPlugin';
    return _this;
  }
  _createClass(VariantsPlugin, [{
    key: "install",
    value: function install(pluginManager) {
      VcfAdapterF(pluginManager);
      VcfTabixAdapterF(pluginManager);
      VariantFeatureWidgetF(pluginManager);
      VariantTrackF(pluginManager);
      ExtensionPointsF(pluginManager);
      LinearVariantDisplayF(pluginManager);
      StructuralVariantChordRendererF(pluginManager);
      ChordVariantDisplayF(pluginManager);
    }
  }]);
  return VariantsPlugin;
}(Plugin);
export { VariantsPlugin as default };
export { default as VcfFeature } from './VcfFeature';